import { useMemo } from 'react';
import { bi } from '../../../services/loggers/bi';
import { mediaManagerTrashButtonsClick } from '@wix/bi-logger-media-manager-g6/v2';

export enum TrashButtons {
  EmptyTrash = 'empty_trash',
  Restore = 'restore',
  DeleteForever = 'delete_forever',
}

export const useTrackTrashButtons = () =>
  useMemo(
    () => ({
      trackRestoreButtonClicked: () =>
        bi.logger().report(mediaManagerTrashButtonsClick({ target: TrashButtons.Restore })),
      trackEmptyTrashButtonClicked: () =>
        bi.logger().report(mediaManagerTrashButtonsClick({ target: TrashButtons.EmptyTrash })),
      trackDeleteForeverButtonClicked: () =>
        bi.logger().report(mediaManagerTrashButtonsClick({ target: TrashButtons.DeleteForever })),
    }),
    [],
  );
